export function UsagiKorobuIcon({ className = "" }: { className?: string }) {
  return (
    <svg
      width="240"
      height="80"
      viewBox="0 0 240 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_usagi)">
        <path
          d="M12.7674 58.1789C12.7674 58.1789 10.8001 53.198 8.91663 50.2263C7.11684 47.422 3.26611 44.1572 3.26611 44.1572C3.26611 44.1572 6.53086 41.5203 8.79106 38.5486C10.8838 35.8279 13.4789 30.6797 13.4789 30.6797C13.4789 30.6797 15.488 35.6187 17.7482 38.8415C19.6735 41.604 22.9801 44.7013 22.9801 44.7013C22.9801 44.7013 19.2968 47.6731 17.3296 50.017C15.2787 52.4865 12.7674 58.1789 12.7674 58.1789Z"
          fill="#E1FF60"
          stroke="black"
          strokeWidth="4.18557"
          strokeMiterlimit="10"
        />
        <path
          d="M72.2852 61.8634C63.7466 62.0308 59.1425 72.2017 59.1425 72.2017C59.1425 72.2017 52.3619 52.8644 34.8662 52.6133"
          stroke="black"
          strokeWidth="4.18557"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M97.0213 63.5378C102.916 63.5378 107.695 58.7593 107.695 52.8646C107.695 46.97 102.916 42.1914 97.0213 42.1914C91.1267 42.1914 86.3481 46.97 86.3481 52.8646C86.3481 58.7593 91.1267 63.5378 97.0213 63.5378Z"
          fill="#F4E6DC"
          stroke="black"
          strokeWidth="4.18557"
          strokeMiterlimit="10"
        />
        <path
          d="M128.791 35.3276C128.791 35.3276 120.754 33.193 117.95 30.5979C115.146 28.0029 114.518 25.4497 114.518 25.4497C114.518 25.4497 103.845 30.1794 97.2314 28.8818C90.6182 27.5843 88.3998 25.0311 87.5627 21.8082C86.7256 18.5853 116.527 1.88492 122.973 3.81028C129.418 5.73564 136.241 28.254 136.659 30.8072C137.078 33.3604 128.832 35.3276 128.832 35.3276H128.791Z"
          fill="#F4E6DC"
          stroke="black"
          strokeWidth="4.18557"
          strokeMiterlimit="10"
        />
        <path
          d="M226.649 52.2799C226.189 29.8452 207.396 9.04297 184.835 9.04297H165.833C155.118 9.04297 141.724 18.6698 138.417 28.2966H132.6C120.503 28.2966 110.709 38.0908 110.709 50.1871C110.709 62.2834 120.503 72.0776 132.6 72.0776H158.257C158.634 72.0776 158.969 71.9939 159.345 71.9521C160.057 72.0358 160.81 72.0776 161.522 72.0776H207.689C211.079 72.0776 214.218 71.115 216.981 69.5663C218.948 71.9521 221.878 73.5007 225.226 73.5007C231.128 73.5007 235.899 68.7292 235.899 62.8275C235.899 57.3863 231.839 52.9496 226.607 52.2799H226.649Z"
          fill="#F4E6DC"
          stroke="black"
          strokeWidth="4.18557"
          strokeMiterlimit="10"
        />
        <path
          d="M136.87 50.7713C136.87 46.1018 133.084 42.3164 128.415 42.3164C123.745 42.3164 119.96 46.1018 119.96 50.7713V53.9941C119.96 58.6636 123.745 62.449 128.415 62.449C133.084 62.449 136.87 58.6636 136.87 53.9941V50.7713Z"
          fill="white"
          stroke="black"
          strokeWidth="4.18557"
          strokeMiterlimit="10"
        />
        <path
          d="M119.833 50.7713C119.833 46.1018 116.047 42.3164 111.378 42.3164C106.708 42.3164 102.923 46.1018 102.923 50.7713V53.9941C102.923 58.6636 106.708 62.449 111.378 62.449C116.047 62.449 119.833 58.6636 119.833 53.9941V50.7713Z"
          fill="white"
          stroke="black"
          strokeWidth="4.18557"
          strokeMiterlimit="10"
        />
        <path
          d="M104.137 53.4931L112.885 48.3867"
          stroke="black"
          strokeWidth="4.18557"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M104.304 50.3516L113.722 53.6582"
          stroke="black"
          strokeWidth="4.18557"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M120.961 53.4931L129.751 48.3867"
          stroke="black"
          strokeWidth="4.18557"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M121.174 50.3516L130.591 53.6582"
          stroke="black"
          strokeWidth="4.18557"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M154.699 77.4362C160.594 77.4362 165.372 72.6577 165.372 66.763C165.372 60.8684 160.594 56.0898 154.699 56.0898C148.804 56.0898 144.026 60.8684 144.026 66.763C144.026 72.6577 148.804 77.4362 154.699 77.4362Z"
          fill="#F4E6DC"
          stroke="black"
          strokeWidth="4.18557"
          strokeMiterlimit="10"
        />
        <path
          d="M138.208 21.5133C151.267 17.83 162.903 27.3731 166.461 30.303C173.785 36.3302 181.989 46.9615 178.934 51.2727C177.134 53.8259 171.902 53.2817 168.219 52.8213C147.249 50.3518 127.493 33.484 130.8 25.8244C131.888 23.3131 135.153 22.3922 138.25 21.5133H138.208Z"
          fill="#F4E6DC"
          stroke="black"
          strokeWidth="4.18557"
          strokeMiterlimit="10"
        />
        <path
          d="M227.735 22.4356C233.352 22.4356 237.906 17.8819 237.906 12.2647C237.906 6.64743 233.352 2.09375 227.735 2.09375C222.118 2.09375 217.564 6.64743 217.564 12.2647C217.564 17.8819 222.118 22.4356 227.735 22.4356Z"
          fill="#F4E6DC"
          stroke="black"
          strokeWidth="4.18557"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_usagi">
          <rect width="240.001" height="79.5258" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
